import Header from '@/@types/header';

export default class companyHeaders {
  public static header: Header[] = [
    {
      text: 'Id',
      align: 'start',
      sortable: false,
      value: 'id',
      class: 'item-table-header item-table-header-company',
    },
    {
      text: 'Name',
      align: 'start',
      sortable: false,
      value: 'name',
      class: 'item-table-header item-table-header-company',
    },
    {
      text: 'Sienge Id',
      align: 'start',
      sortable: false,
      value: 'siengeId',
      class: 'item-table-header item-table-header-company',
    },
    {
      text: 'Fund Administrator',
      align: 'start',
      sortable: false,
      value: 'fundAdministratorName',
      class: 'item-table-header item-table-header-company',
    },
    {
      text: 'CNPJ',
      align: 'start',
      sortable: false,
      value: 'cnpj',
      class: 'item-table-header item-table-header-company',
    },
    {
      text: 'Required Approvers',
      align: 'center',
      sortable: true,
      value: 'requiredApprovers',
      class: 'item-table-header item-table-header-company',
    },
  ];
}
